
//removeIf(production)
import FloatWithTwoDecimals from "../../domain/entities/float-with-two-decimals";
//endRemoveIf(production)

class UrlDataExtract {
    private static url: string;
    public static cups?: string;
    public static price?: FloatWithTwoDecimals;
    public static powerP1?: string;
    public static powerP2?: string;
    public static powerP3?: string;


    constructor() {
        throw new Error("UrlDataExtract class cannot be instantiated directly. Use of() instead.");
    }

    private static validate(): boolean {
        if (this.url && this.url.startsWith("http") && this.url.includes("cups=") && this.url.includes("imp=")) {
            return true;
        } else {
            return false;
        }
    }

    private static getCups() {
        let cups = this.url.split("cups=")[1];
        cups = cups.split("&")[0];

        this.cups = cups;
    }

    private static getPrice() {
        let  price = this.url.split("imp=")[1];
        price = price.split("&")[0];
        price = price.split("eur")[0];
        this.price = new FloatWithTwoDecimals(+price);
    }

    private static getPowerP1() {
        let powerP1 = this.url.split("cfP1=")[1];
        powerP1 = powerP1.split("&")[0];
        powerP1 = powerP1.split("kWh")[0];

        this.powerP1 = powerP1;
    }

    private static getPowerP2() {
        let powerP2 = this.url.split("cfP2=")[1];
        powerP2 = powerP2.split("&")[0];
        powerP2 = powerP2.split("kWh")[0];

        this.powerP2 = powerP2;
    }

    private static getPowerP3() {
        let powerP3 = this.url.split("cfP3=")[1];
        powerP3 = powerP3.split("&")[0];
        powerP3 = powerP3.split("kWh")[0];

        this.powerP3 = powerP3;
    }

    public static of(url: string): any {
        this.url = url;
        
        if (this.validate()) {
            this.getCups();
            this.getPrice();
            this.getPowerP1();
            this.getPowerP2();
            this.getPowerP3();

            return {
                cups: this.cups,
                price: this.price,
                powerP1: this.powerP1,
                powerP2: this.powerP2,
                powerP3: this.powerP3
            }
        }

        return false;
    }
}

// https://comparador.cnmc.gob.es/comparador/QRE?bs=0&cp=39477&peaje=18&pP1=4.6kW&pP2=4.6kW&caP1=696kWh&caP2=594kWh&caP3=995kWh&iniA=2021-08-07&finA=2022-09-06&tc=0&finPen=2023-07-22&reg=0&imp=100.63eur&cfP1=53kWh&cfP2=51kWh&cfP3=95kWh&iniF=2022-08-07&finF=2022-09-06&impSA=0eur&impOtros=38.54eur&exc=0eur&com=R2-506&cups=ES0027460000041671QR0F&pmaxP1=2694kW&pmaxP2=3364kW

//removeIf(production)
export default UrlDataExtract;
//endRemoveIf(production)